import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Text, Title } from '@nimbus-ds/components';
import ErrorImage from './error.png';
import { TFunction } from 'i18next';

interface ErrorScreenInterface {
  onReload: () => void;
  title?: TFunction | string;
}

function ErrorScreen({ onReload, title }: ErrorScreenInterface): JSX.Element {
  const { t } = useTranslation();

  const getTitle = () => {
    if (!title) return t('errorPage.title');
    if (typeof title === 'function') {
      return (title as () => string)();
    }
    return title;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      gap="4"
      paddingX="0-5"
    >
      <Box>
        <img src={ErrorImage} width="100%" style={{ maxWidth: '480px' }} />
      </Box>
      <Title as="h2">{getTitle()}</Title>
      <Text color="neutral-textHigh">{t('errorPage.text')}</Text>
      <Button appearance="primary" onClick={onReload}>
        {t('errorPage.action')}
      </Button>
    </Box>
  );
}

export default ErrorScreen;
